import React from 'react';

/** 无外壳布局：用于登录、异常页等不需要导航的场景 */
export default function BlankLayout({
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '100vh'
    }
  }, children);
}